import { useMutation } from '@tanstack/react-query';
import authAxios from '../../utils/interceptorPOSAuth';

export const useDeleteUserTokenData = () => {
  return useMutation(async (values) => {
    const res = await authAxios({
      method: 'DELETE',
      url: `userAuth/token/${values?.userId}`,
    });

    return res;
  });
};
